import { Component, OnInit } from '@angular/core';

declare var $: any;

@Component({
  selector: 'app-leveringsvoorwaardenFR',
  templateUrl: '../../../assets/html/leveringsvoorwaardenFR.html',
  styleUrls: ['./leveringsvoorwaardenFR.component.css']
})
export class LeveringsvoorwaardenFRComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    var t = $('[data-parallax="scroll"]').data('imageSrc');
    $('[data-parallax="scroll"]').parallax({imageSrc: t});
  }

}
